export default __webpack_public_path__ + "media/images/images_v2/ongletwhite-right3-bba490eeafde97fc323968a16100fdb2.png";